import { useInfiniteQuery } from '@tanstack/react-query';
import { fetchAllMessages } from '../services/AdministrationService';

export const useAllMessages = () => {
    const query = useInfiniteQuery({
        queryKey: ['admin', 'messages'],
        queryFn: ({ pageParam }: { pageParam: string | null }) => 
            fetchAllMessages({ limit: 10, nextToken: pageParam }),
        getNextPageParam: (lastPage) => lastPage?.nextToken || undefined,
        initialPageParam: null as string | null
    });

    const allItems = query.data?.pages?.flatMap(page => page?.items || []) || [];

    return {
        items: allItems,
        visibleItems: allItems,
        visibleCount: allItems.length,
        loading: query.isLoading,
        nextToken: query.hasNextPage ? 'has-more' : null,
        isFetchingNextPage: query.isFetchingNextPage,
        fetchRecords: () => {
            if (query.hasNextPage) {
                query.fetchNextPage();
            }
        }
    };
};
